<template>
	<div>
		<h1 class="view-title">
			ADMINISTRADORES - LISTAGEM
		</h1>

		<div class="inner-content shadowed">
			<div class="inner-content-title">
				Lista

				<button class="button-edit admin-create-btn" @click="current = 'new'">
					<i class="fa fa-plus"></i> NOVO
				</button>

				<div class="admin-filter-wrapper">
					<input class="admin-filter-input" type="text" placeholder="Buscar" v-model="search" @keydown.enter.prevent="load(true)" />
					<i class="fa fa-fw fa-search"></i>
				</div>
			</div>

			<div class="row">
				<div class="col-xs">
					
					<Table 
					:loading="loading"
					:headers="headers" 
					:modifiers="modifiers" 
					:ordering="[]" 
					:list="list" 
					:page="page"
					:per_page="20" 
					:total="total" 
					@next="() => { page++; load(); }" 
					@prev="() => { page--; load(); }"
					v-slot="{item}">

						<button class="button-edit" @click="current = item" title="Alterar">
							<i class="fa fa-fw fa-edit"></i> Alterar
						</button>

						<button class="button-remove" @click="remove(item)" title="Excluir" v-if="item.id > 1">
							<i class="fa fa-fw fa-trash"></i> Excluir
						</button>

					</Table>

				</div>

			</div>
		</div>

		<AdminAdminForm v-if="current" :current="current" />


	</div>
</template>

<script>
import Api from "@/lib/Api";

import Table from "@/components/Table";
import AdminAdminForm from './AdminAdmin/AdminAdminForm';

export default {
	name: "AdminAdmin",

	components: { Table, AdminAdminForm },

	data: function() {
		return {
			search: "",

			loading: true,
			list: [],
			page: 0,
			total: 0,
			headers: {
				id: "#",
				name: "Nome",
				username: "Usuário",
				status: "Status"
			},
			modifiers: {
				status: function(s) {
					if (s) return "<i class='far fa-fw fa-check-square'></i>";
					return "<i class='far fa-fw fa-square'></i>";
				}
			},
			
			current: false,
		};
	},

	mounted: function() {
		this.load();
	},

	activated: function() {
		this.load();
	},

	methods: {
		load: async function(is_search) {
			let form = {};

			if (this.search) {
				form.search = this.search;
			}

			if (is_search) {
				this.page = 0;
			}

			form.page = this.page;

			this.list = [];
			this.loading = true;
			let res = await Api.post_admin("admin/list", form);
			this.loading = false;

			if (res.error) {
				this.$notification.error(res.data);
				return;
			}

			this.list = res.data;
			this.total = res.total;
		},

		open: function(item) {
			this.current = item;
		},

		remove: async function(item) {
			let confirm = await this.$alert.confirm("Tem certeza que deseja excluir o item?");
			if (!confirm) return;

			let res = await Api.post_admin('admin/delete', {id: item.id});
			if (res.error) {
				this.$notification.error(res.data);
			} else {
				this.$notification.success("Removido com sucesso.");
			}

			this.load();
		}
	}
}
</script>

<style scoped>
.details-label {
	width: 100%;
	font-weight: bold;
	padding: 10px;
}

.details-value {
	width: 100%;
	padding: 10px;
	font-size: 14px;
	color: #999;
}

hr {
	border: none;
	background: none;
	border-top: 1px solid #ddd;
}

.admin-filter-wrapper {
	position: relative;
	float: right;
	width: 200px;
	height: 30px;
	margin-top: 15px;
	color: #999;
}

.admin-filter-wrapper > i {
	position: absolute;
	top: 7px;
	left: 7px;
}

.admin-filter-input {
	position: absolute;
	width: 100%;
	height: 30px;
	padding-left: 30px;
	border-radius: 4px;
	border: 1px solid #ccc;
}


.admin-create-btn {
	float: right;
	margin-top: 16px;
	margin-left: 15px;
	padding-left: 15px;
	padding-right: 15px;
}
</style>